export default __webpack_public_path__ + "assets/6c6608365f51f616cf97fcfa5428cb76.jpeg";